<template>
  <div v-if="isMetaModelReady">
    <div class="field">
      <label class="label">Status</label>
      <SelectContainer
        v-model="selected"
        :options="statusOptions"
        :track-by="trackByKey"
        :label="labelKey"
        placeholder="Select..."
        @input="handleChangeStatus"
      />
    </div>
  </div>
</template>

<script>
import SelectContainer from '@/components/SelectContainer.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'BatchEditOrderStatus',
  components: {
    SelectContainer,
  },
  data() {
    return {
      selected: '',
    }
  },
  methods: {
    handleChangeStatus(newVal) {
      this.$emit('input', newVal)
    },
  },
  computed: {
    ...mapGetters('meta', ['getMeta', 'isMetaModelReady']),
    meta() {
      return this.getMeta('stocks', 'ordereditem', 'DEFAULT')
    },
    statusOptions() {
      if (!this.isMetaModelReady) {
        return []
      }
      const slot = this.meta.model.attributes.find(
        (attr) => attr.name === 'status',
      )
      return slot.choices.list
    },
    trackByKey() {
      if (!this.isMetaModelReady) {
        return []
      }
      const slot = this.meta.model.attributes.find(
        (attr) => attr.name === 'status',
      )
      return slot.choices.value_field
    },
    labelKey() {
      if (!this.isMetaModelReady) {
        return []
      }
      const slot = this.meta.model.attributes.find(
        (attr) => attr.name === 'status',
      )
      return slot.choices.label_field
    },
  },
}
</script>
